export const differenceNumbers = (total = 0, number = 0) => {
	return number - total;
};

export const percentageNumber = (total = 0, difference = 0) => {
	return (difference * 100) / total;
};

export const reduceSum = (array = []) => {
	return array.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
};

export const findEqualJson = (arrays = [], nameOne = "", nameTwo = "") => {
	return arrays.find((arrays) => arrays[nameOne] === nameTwo);
};

export const filterJson = (arrays = [], nameOne = "", nameTwo = "") => {
	return arrays.filter((arrays) => arrays[nameOne] === nameTwo);
};

export const calculateAverage = (totalCount = 0, sumTotal = 0) => {
	return sumTotal / totalCount;
};

export const valueFloat2 = (value = 0) => {
	return parseFloat(value.toFixed(2));
};

export const percentValue = (total = 0, number = 0) => {
	const roundedPercentage = parseFloat(percentageNumber(total, number).toFixed(2));
	return isNaN(roundedPercentage) ? 0 : roundedPercentage;
};

export const convertToFormat = (number, typeLocal = "en-US", currency = "USD") => {
	return number.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
	});
};

export const truncateNumber = (number = 0) => {
	return Number(Number(number).toFixed(2));
};
